import axios from 'axios';
import { getQueryObject, formatTarTime } from './index'
const baseURL = process.env.NODE_ENV == "production" ? 'https://api-hsr.huashouren.com' : 'https://api-test.huashouren.com'
    // const baseURL = process.env.NODE_ENV == "production" ? 'https://bdprod.huashouren.com' : 'https://bdstag.huashouren.com'


/** 回传 **/
export function pathBack(url) {
    if (formatTarTime(new Date('2025-08-01'))) {
        return false
    }
    let apiPath, apiParams
    const parms = getQueryObject()

    // if (parms.channels == 'baiduxxl' || parms.channels == '001002001') {
    //     apiPath = '/api/advert/launch/getPutIndex'
    //     apiParams = {
    //         putIndex: encodeURIComponent(url)
    //     }
    // } else {
    apiPath = '/api/advert/launch/getGeneralIndex'
    apiParams = {
            putIndex: encodeURIComponent(url),
            channels: parms.channels || '',
            productId: parms.productId || '1',
            cctid: parms.cctid || '',
            strid: parms.strid || '',
            bepid: parms.bepid || '',
            pathId: parms.bd_vid || parms.track_id || parms.qhclickid || parms.uctrackid || parms.sourceid || '',
        }
        // }
    return axios({
        method: "POST",
        url: `${baseURL}${apiPath}`,
        data: apiParams
    }).then(res => {
        if (res.data.code == 200) {
            return res.data.data
        } else {
            console.log(res.data.message)
        }
    })
}
export function pathBackNew(url, channels) {
    if (formatTarTime(new Date('2025-08-01'))) {
        return false
    }
    let apiPath, apiParams
    const parms = getQueryObject()

    // if (parms.channels == 'baiduxxl' || parms.channels == '001002001' || channels == '001002001') {
    //     apiPath = '/api/advert/launch/getPutIndex'
    //     apiParams = {
    //         putIndex: encodeURIComponent(url),
    //         channels: channels ? channels : '',
    //     }
    // } else {
    apiPath = '/api/advert/launch/getGeneralIndex'
    apiParams = {
            putIndex: encodeURIComponent(url),
            channels: channels ? channels : '',
            productId: parms.siteid || parms.productId || '1',
            cctid: parms.cctid || '',
            strid: parms.strid || '',
            bepid: parms.bepid || '',
            pathId: parms.bd_vid || parms.track_id || parms.qhclickid || parms.uctrackid || parms.sourceid || ''
        }
        // }
    return axios({
        method: "POST",
        url: `${baseURL}${apiPath}`,
        data: apiParams
    }).then(res => {
        if (res.data.code == 200) {
            return res.data.data
        } else {
            console.log(res.data.message)
        }
    })
}

/** 埋点 **/
export function commonPoint(pathid, productId, key, val) {
    let params = {
        clickId: pathid,
        productId: productId,
        [key]: val
    }
    axios({
        method: "POST",
        url: `${baseURL}/api/advert/launch/insertApplyEc`,
        data: params
    }).then(res => {
        if (res.data.code !== 200) {
            console.log(res.data.message)
        }
    })
}



// WEBPACK FOOTER //
// ./src/utils/request.js